import { createContext, useContext } from 'react'

export const OpenModalFromPaywallContext = createContext<(() => void) | null>(null)

export function useOpenModalFromPaywall() {
  const openModal = useContext(OpenModalFromPaywallContext)

  if (process.env.NODE_ENV !== 'production' && openModal === null) {
    console.warn(
      '[StaticOfferPaywall] useOpenModalFromPaywall: no OpenModalFromPaywallContext.Provider found. ' +
        'The CTA will be a no-op. Wrap the component with BoxPaywall or provide the context manually.'
    )
  }

  return openModal
}
